<template>
  <div class="result-card" :class="{ 'result-card--disabled': entreprise.actif === 0 }">
    <div class="result-card__header">
      <div class="result-card__title-block">
        <span class="result-card__name">{{ entreprise.raison_sociale }}</span>
        <span class="result-card__code">{{ entreprise.code_client_fta }}</span>
      </div>
      <div class="result-card__badges">
        <span v-if="entreprise.actif === 0" class="badge badge--disabled">Désactivé</span>
        <span v-if="entreprise.type_client && entreprise.type_client.startsWith('client')" class="badge badge--client">Client</span>
        <span v-else-if="entreprise.type_client && entreprise.type_client.startsWith('prospect')" class="badge badge--prospect">Prospect</span>
      </div>
    </div>

    <div class="result-card__body">
      <div v-if="entreprise.adresse || entreprise.ville" class="result-card__info">
        <v-icon x-small class="mr-1" color="#888">mdi-map-marker</v-icon>
        <span>{{ [entreprise.adresse, entreprise.code_postal, entreprise.ville].filter(Boolean).join(', ') }}</span>
      </div>
      <div v-if="entreprise.email_entreprise" class="result-card__info">
        <v-icon x-small class="mr-1" color="#888">mdi-email</v-icon>
        <a :href="`mailto:${entreprise.email_entreprise}`">{{ entreprise.email_entreprise }}</a>
      </div>
      <div v-if="entreprise.telephone_fixe" class="result-card__info">
        <v-icon x-small class="mr-1" color="#888">mdi-phone</v-icon>
        <a :href="`tel:${entreprise.telephone_fixe}`">{{ formattedPhone }}</a>
      </div>
    </div>

    <div class="result-card__footer">
      <router-link
        :to="{ name: 'client', params: { id_entreprise: entreprise.id_entreprise } }"
        @click.native="$store.state.currentTab = 0"
        class="result-card__link"
      >
        Voir la fiche
        <v-icon x-small class="ml-1">mdi-arrow-right</v-icon>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["entreprise", "i", "max"],
  computed: {
    formattedPhone() {
      const t = this.entreprise.telephone_fixe;
      if (!t) { return ""; }
      if (t.length === 10) {
        return t.match(/.{1,2}/g).join(" ");
      }
      return t;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.result-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 8px;
  background: #fff;
  transition: box-shadow 0.15s, border-color 0.15s;

  &:hover {
    box-shadow: 0 2px 8px rgba(11, 135, 186, 0.12);
    border-color: #b3d9ec;
  }

  &--disabled {
    opacity: 0.65;
    background: #fafafa;
  }
}

.result-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.result-card__title-block {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
  min-width: 0;
}

.result-card__name {
  font-weight: 700;
  font-size: 0.95rem;
  color: $background-color-blue;
  line-height: 1.3;
}

.result-card__code {
  font-size: 0.75rem;
  color: #999;
  font-weight: 400;
  white-space: nowrap;
}

.result-card__badges {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  &--client {
    background: #e3f2fd;
    color: #1565c0;
  }

  &--prospect {
    background: #fff3e0;
    color: #b34400;
  }

  &--disabled {
    background: #fce4e4;
    color: #b71c1c;
  }
}

.result-card__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;
}

.result-card__info {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: #555;

  a {
    color: $font-color-link-search-result;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.result-card__footer {
  border-top: 1px solid #f0f0f0;
  padding-top: 6px;
  text-align: right;
}

.result-card__link {
  font-size: 0.78rem;
  font-weight: 700;
  color: $background-color-btn;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: darken(#FF9900, 10%);
  }
}
</style>
